import React, { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useAuth } from "../../Context/AuthContext";
import styles from "./styles/OTP.module.css";
import { useNavigate } from "react-router-dom";
import config from "../../config.js";
import { submitCaptcha } from "../../Utils/captcha";
import { PaymentSuccess } from "../User/My Account/PaymentSuccess";
import { formatEmail } from "../../Utils/formatEmail";
import { getOTPoptions } from "../../Utils/UserLogin";
import Loading from "../Loading/Loading";
import parse from "html-react-parser";
import { MFAOptions } from "./MFAoptions";
import { LanguageContext } from "../../Context/changeLanguageProvider.js";
import { formattingRedirectionUrl } from "../../Utils/redirectingUrl.js";

const base_url = config.base_url;

export function OTP() {
  const [OTP, setOTP] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  const [content, setContent] = useState(websiteCurrentLang.content.Login.Otp);
  useEffect(() => {
    setContent(websiteCurrentLang.content.Login.Otp);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [loginError, setLoginError] = useState(null);
  const auth = useAuth();
  const navigate = useNavigate();
  const [modal, setModal] = useState();
  const [options, setOptions] = useState();
  const [method, setMethod] = useState();
  const [showOptions, setShowOptions] = useState(false);
  const [tooLong, setTooLong] = useState(false);

  const timeoutDuration = 120000;
  useEffect(() => {
    setModal(<Loading text={content.otpText1} />);
    getOTPoptions()
      .then((res) => {
        setModal();
        if (res.status !== 200) throw new Error();
        return res.json();
      })
      .then((data) => {
        setOptions(data);
        setMethod(data.main);
      })
      .catch((e) => {
        console.log(e);
        navigate("/login", { replace: true });
      });
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      console.log("tooLoong");
      navigate("/login", { replace: true });
      setTooLong(true);
    }, timeoutDuration);

    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    console.log("ha entrado");
    console.log(auth.userInfo);
    if (auth.userInfo.OTP === "true") {
      console.log("El usuario ya ha pasado el OTP");

      navigate("/user/dashboard", { replace: true });
      // navigate("/user/account", { replace: true });
    }
  }, [auth.userInfo, navigate]);
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu";
    document.body.appendChild(script);
  }, []);
  const showError = (error) => {
    setLoginError(error);
    setTimeout(() => {
      setLoginError(null);
    }, 3000);
  };
  const handleLogin = async (token) => {
    let credentials = {};
    credentials.otp = OTP;
    fetch(base_url + "login/OTP", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `OTP=${OTP}&token=${token}`,
      credentials: "include",
    })
      .then(async (res) => {
        if (res.status === 498) Error(dublicatedcontent.dublicatedText49);
        else if (res.status === 403) throw new Error(content.otpWrongOtpError1);
        else if (res.status === 429) throw new Error(content.otpBlockedError1);
        else if (res.status === 429)
          throw new Error(dublicatedcontent.dublicatedText67);
        else if (res.status === 302) {
          await res.text().then((url) => {
            auth.login(true);
            auth.setOTP(true);
            navigate(url, { replace: true, state: { token: true } });
          });
        } else if (res.status === 200) {
          await res.json().then((data) => {
            if (data?.error === "Wrong OTP")
              showError(content.otpWrongOtpError1);
            else if (data?.error) showError(data.error);
            else {
              auth.login(true);
              auth.setOTP(true);
              console.log(data?.data?.user_type);
              // if (data?.data?.user_type?.toLowerCase() === "partner")
              // return navigate("/user/account", { replace: true });
              if (data?.data?.first_login)
                return navigate("/user/prepare", {
                  replace: true,
                  state: { prepare: true },
                });
              // else if (data?.webinar){
              //   return navigate("/user/plan", { replace: true });
              // }
              else return navigate("/user/dashboard", { replace: true });
            }
          });
        } else throw new Error("Something went wrong. try it later");
      })
      .catch((err) => {
        console.log(err);
        showError(err.message);
      })
      .finally(() => {
        setButtonDisabled(false);
      });
  };
  const submitCaptchaOTP = (e) => {
    e.preventDefault();
    window.grecaptcha.ready(() => {
      setButtonDisabled(true);
      window.grecaptcha
        .execute("6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu")
        .then((token) => {
          if (!OTP) return showError(content.otpWrongOtpError1);
          handleLogin(token);
        })
        .catch((e) => {
          console.log(e);
          setButtonDisabled(false);
        })
        .finally(() => {
          setButtonDisabled(false);
        });
    });
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      submitCaptchaOTP(e);
    }
  };

  return (
    <div className={styles.main_div}>
      <div
        className={styles.home_link}
        onClick={() => {
          window.location.href = formattingRedirectionUrl("");
        }}
      >
        {dublicatedcontent.dublicatedText41}
      </div>
      <div className={styles.title}>{content.loginTitle2}</div>
      <div className={styles.sub_title}>
        {content.otpTitle1}
        <br></br>
        {!showOptions && (
          <>
            {method === "authenticator" && (
              <>{dublicatedcontent.authentication_app_otp_code}</>
            )}
            {method === "email" && <>{dublicatedcontent.email_otp_code}</>}
          </>
        )}
      </div>
      {showOptions && (
        <MFAOptions
          options={options}
          setMethod={(e) => setMethod(e)}
          setShowOptions={(e) => setShowOptions(e)}
        />
      )}
      {!showOptions && (
        <div className={styles.main_box}>
          <div className={styles.head}>
            <div className={styles.top}>
              {content.otpText2} {formatEmail(auth.email)}
            </div>
            <div className={styles.bottom}>
              {content.otpText3}{" "}
              <span
                className={styles.top_link}
                onClick={() => navigate("/login", { replace: true })}
              >
                {dublicatedcontent.dublicatedText53}
              </span>
            </div>
          </div>
          <div className={styles.top}>
            {/* {options?.authenticator ? <div className={styles.input_text}>Insert the OTP code from your authentication app</div>:<div className={styles.input_text}>An OTP code was sent to your email address</div>} */}
            {method === "authenticator" && (
              <div className={styles.input_text}>{content.otpText5}</div>
            )}
            {method === "email" && (
              <div className={styles.input_text}>
                {dublicatedcontent.dublicatedText54}
              </div>
            )}
            {tooLong ? (
              <div className={styles.too_long}>
                <div className={styles.red_text}>
                  {dublicatedcontent.dublicatedText55}
                </div>
                <span
                  className={styles.login_link}
                  onClick={() => navigate("/login", { replace: true })}
                >
                  {dublicatedcontent.dublicatedText56}
                </span>
              </div>
            ) : (
              <input
                autoFocus
                onKeyDown={handleEnter}
                className={`${styles.input} ${
                  loginError ? styles.field_error : ""
                }`}
                value={OTP}
                onChange={(e) => {
                  setOTP(e.target.value);
                }}
                placeholder={dublicatedcontent.dublicatedText57}
              ></input>
            )}
            {loginError ? (
              <div className={styles.login_error}>{loginError}</div>
            ) : null}
            <button
              disabled={buttonDisabled}
              onClick={(e) => submitCaptchaOTP(e)}
              className={styles.login_button}
            >
              {dublicatedcontent.dublicatedText3}
            </button>
          </div>

          {options?.authenticator && options?.email && (
            <>
              <div className={styles.center}>
                <div className={styles.login_rect}></div>
              </div>
              <div className={styles.bottom}>
                {method === "email" && (
                  <div className={styles.not_a_customer}>
                    {content.otpText9}
                  </div>
                )}
                {method === "authenticator" && (
                  <div className={styles.not_a_customer}>
                    {content.otpText10}
                  </div>
                )}
                {
                  <div
                    onClick={() => setShowOptions(true)}
                    className={styles.login_beneficiary}
                  >
                    {content.otpText11}
                  </div>
                }
              </div>
            </>
          )}
        </div>
      )}
      {modal}
    </div>
  );
}
